import React, { Component } from "react";
import { Col, Row, Grid, Panel } from "react-bootstrap";
import classnames from "classnames";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import Table from "../../../../components/common/table/Table";
import styles from "./AdminDashboard.scss";
import BarChart from "../../../../components/common/chart/bar/BarChart";
import moment from "moment";

class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weeklyProjectsObject: {
        created: {
          label: "Created",
          labels: [],
          data: []
        },
        approved: {
          label: "Approved",
          labels: [],
          data: []
        },
        pitched: {
          label: "Pitched",
          labels: [],
          data: []
        },
        hired: {
          label: "Hired",
          labels: [],
          data: []
        }
      },
      weeklyProjectsSelected: {
        label: "Created",
        labels: [],
        data: []
      },
      weeklyUsersObject: {
        signedUp: {
          label: "Signed Up",
          labels: [],
          data: []
        },
        accepted: {
          label: "Accepted",
          labels: [],
          data: []
        },
        matched: {
          label: "Matched",
          labels: [],
          data: []
        },
        pitched: {
          label: "Pitched",
          labels: [],
          data: []
        },
        hired: {
          label: "Hired",
          labels: [],
          data: []
        }
      },
      weeklyUsersSelected: {
        label: "Signed Up",
        labels: [],
        data: []
      }
    };
  }

  fillWeeklyProjects(nextProps) {
    const { weeklyProjects } = nextProps;
    for (let index = 0; index < weeklyProjects.length; index++) {
      const project = weeklyProjects[index];
      const projectEntries = Object.entries(project)[0];
      const projectName = projectEntries[0];
      const objDates = projectEntries[1];
      const dateEntries = Object.entries(objDates);
      dateEntries.forEach(date => {
        const label = date[0].toUpperCase();
        const data = date[1];
        switch (projectName) {
          case "Created":
            this.state.weeklyProjectsObject.created.labels.push(label);
            this.state.weeklyProjectsObject.created.data.push(data);
            break;
          case "Approved":
            this.state.weeklyProjectsObject.approved.labels.push(label);
            this.state.weeklyProjectsObject.approved.data.push(data);
            break;
          case "Pitched":
            this.state.weeklyProjectsObject.pitched.labels.push(label);
            this.state.weeklyProjectsObject.pitched.data.push(data);
            break;
          case "Hired":
            this.state.weeklyProjectsObject.hired.labels.push(label);
            this.state.weeklyProjectsObject.hired.data.push(data);
            break;
          default:
            break;
        }
      });
    }

    // Default selected to Created
    this.setState({
      weeklyProjectsSelected: this.state.weeklyProjectsObject.created
    });
  }

  fillWeeklyUsers(nextProps) {
    const { weeklyUsers } = nextProps;
    for (let index = 0; index < weeklyUsers.length; index++) {
      const project = weeklyUsers[index];
      const projectEntries = Object.entries(project)[0];
      const projectName = projectEntries[0];
      const objDates = projectEntries[1];
      const dateEntries = Object.entries(objDates);
      dateEntries.forEach(date => {
        const label = date[0].toUpperCase();
        const data = date[1];
        switch (projectName) {
          case "Signed Up":
            this.state.weeklyUsersObject.signedUp.labels.push(label);
            this.state.weeklyUsersObject.signedUp.data.push(data);
            break;
          case "Accepted":
            this.state.weeklyUsersObject.accepted.labels.push(label);
            this.state.weeklyUsersObject.accepted.data.push(data);
            break;
          case "Matched":
            this.state.weeklyUsersObject.matched.labels.push(label);
            this.state.weeklyUsersObject.matched.data.push(data);
            break;
          case "Pitched":
            this.state.weeklyUsersObject.pitched.labels.push(label);
            this.state.weeklyUsersObject.pitched.data.push(data);
            break;
          case "Hired":
            this.state.weeklyUsersObject.hired.labels.push(label);
            this.state.weeklyUsersObject.hired.data.push(data);
            break;
          default:
            break;
        }
      });
    }

    // Default selected to Signed Up
    this.setState({
      weeklyUsersSelected: this.state.weeklyUsersObject.signedUp
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.weeklyProjects !== nextProps.weeklyProjects) {
      this.fillWeeklyProjects(nextProps);
    }
    if (this.props.weeklyUsers !== nextProps.weeklyUsers) {
      this.fillWeeklyUsers(nextProps);
    }
  }

  onWeeklyProjectsChange(index) {
    if (index === 0) {
      // Created
      this.setState({
        weeklyProjectsSelected: this.state.weeklyProjectsObject.created
      });
    } else if (index === 1) {
      // Approved
      this.setState({
        weeklyProjectsSelected: this.state.weeklyProjectsObject.approved
      });
    } else if (index === 2) {
      // Pitched
      this.setState({
        weeklyProjectsSelected: this.state.weeklyProjectsObject.pitched
      });
    } else if (index === 3) {
      // Hired
      this.setState({
        weeklyProjectsSelected: this.state.weeklyProjectsObject.hired
      });
    }
  }

  onWeeklyUsersChange(index) {
    if (index === 0) {
      // Signed Up
      this.setState({
        weeklyUsersSelected: this.state.weeklyUsersObject.signedUp
      });
    } else if (index === 1) {
      // Accepted
      this.setState({
        weeklyUsersSelected: this.state.weeklyUsersObject.accepted
      });
    } else if (index === 2) {
      // Matched
      this.setState({
        weeklyUsersSelected: this.state.weeklyUsersObject.matched
      });
    } else if (index === 3) {
      // Pitched
      this.setState({
        weeklyUsersSelected: this.state.weeklyUsersObject.pitched
      });
    } else if (index === 4) {
      // Hired
      this.setState({
        weeklyUsersSelected: this.state.weeklyUsersObject.hired
      });
    }
  }

  render() {
    const { todo, projectsOverview, membersOverview } = this.props;

    const mappedProjectsOverview = projectsOverview.map((project, index) => {
      return {
        rowKey: index,
        data: [
          {
            displayText: Object.keys(project)[0]
          },
          {
            displayText: project[Object.keys(project)[0]].this_week,
            align: "center",
            bigContent: true
          },
          {
            displayText: project[Object.keys(project)[0]].last_week,
            align: "center",
            bigContent: true
          },
          {
            displayText: project[Object.keys(project)[0]].this_month,
            align: "center",
            bigContent: true
          },
          {
            displayText: project[Object.keys(project)[0]].last_month,
            align: "center",
            bigContent: true
          },
          {
            displayText: project[Object.keys(project)[0]].total,
            align: "center",
            bigContent: true
          }
        ]
      };
    });

    const headers = title => [
      {
        displayText: title,
        sortDisabled: true,
        align: "center",
        main: true
      },
      {
        displayText: "This Week",
        sortDisabled: true,
        align: "center"
      },
      {
        displayText: "Last Week",
        sortDisabled: true,
        align: "center"
      },
      {
        displayText: "This Month",
        sortDisabled: true,
        align: "center"
      },
      {
        displayText: "Last Month",
        sortDisabled: true,
        align: "center"
      },
      {
        displayText: "All Time",
        sortDisabled: true,
        align: "center"
      }
    ];

    const projectsTableData = {
      headers: headers("Projects"),
      rows: mappedProjectsOverview
    };

    const mappedMembersOverview = membersOverview.map((member, index) => {
      return {
        rowKey: index,
        data: [
          {
            displayText: Object.keys(member)[0]
          },
          {
            displayText: member[Object.keys(member)[0]].this_week,
            align: "center",
            bigContent: true
          },
          {
            displayText: member[Object.keys(member)[0]].last_week,
            align: "center",
            bigContent: true
          },
          {
            displayText: member[Object.keys(member)[0]].this_month,
            align: "center",
            bigContent: true
          },
          {
            displayText: member[Object.keys(member)[0]].last_month,
            align: "center",
            bigContent: true
          },
          {
            displayText: member[Object.keys(member)[0]].total,
            align: "center",
            bigContent: true
          }
        ]
      };
    });

    const membersTableData = {
      headers: headers("Members"),
      rows: mappedMembersOverview
    };

    const weeklyProjectsDataset = {
      labels: this.state.weeklyProjectsSelected.labels,
      datasets: [
        {
          label: this.state.weeklyProjectsSelected.label,
          backgroundColor: "#70adcc",
          borderColor: "#70adcc",
          borderWidth: 0,
          hoverBackgroundColor: "#70adcc",
          hoverBorderColor: "#70adcc",
          data: this.state.weeklyProjectsSelected.data
        }
      ]
    };

    const weeklyUsersDataset = {
      labels: this.state.weeklyUsersSelected.labels,
      datasets: [
        {
          label: this.state.weeklyUsersSelected.label,
          backgroundColor: "#95cfb3",
          borderColor: "#95cfb3",
          borderWidth: 0,
          hoverBackgroundColor: "#95cfb3",
          hoverBorderColor: "#95cfb3",
          data: this.state.weeklyUsersSelected.data
        }
      ]
    };

    const userName = localStorage.getItem("userName");
    const date = moment().format("MMMM D, YYYY");

    return (
      <section className={styles.adminCompanyContainer}>
        <ScrollToTopOnMount />
        <section className={styles.textFont}>
          <Grid className={styles.maxWidth}>
            <Row>
              <Col>
                <div className={styles.headerContainer}>
                  <h1>Hi, {userName}!</h1>
                  <div className={styles.headerDate}>{date}</div>
                </div>
              </Col>
            </Row>
            <Row>
              <Panel>
                <Panel.Heading className={styles.panelHeadingContainer}>
                  <Panel.Title
                    componentClass="h3"
                    className={styles.panelHeadingTitle}
                  >
                    TO DO
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body className={styles.panelBodyContainer}>
                  <div className={styles.first}>
                    <div className={styles.panelBodyNumber}>
                      {todo && todo.members && todo.members.approval}
                    </div>
                    <div className={styles.panelBodyDescription}>
                      Members Awaiting Approval
                    </div>
                  </div>
                  <div className={styles.verticalDivider} />
                  <div>
                    <div className={styles.panelBodyNumber}>
                      {todo && todo.projects && todo.projects.review}
                    </div>
                    <div className={styles.panelBodyDescription}>
                      Projects Need Review
                    </div>
                  </div>
                  <div className={styles.verticalDivider} />
                  <div>
                    <div className={styles.panelBodyNumber}>
                      {todo && todo.projects && todo.projects.sow}
                    </div>
                    <div className={styles.panelBodyDescription}>
                      Projects in SOW More than 7 Days
                    </div>
                  </div>
                  <div className={styles.verticalDivider} />
                  <div>
                    <div className={styles.panelBodyNumber}>
                      {todo && todo.projects && todo.projects.pitches}
                    </div>
                    <div className={styles.panelBodyDescription}>
                      Projects with No Pitches in 7 Days
                    </div>
                  </div>
                </Panel.Body>
              </Panel>
            </Row>
            <Row>
              <div className={styles.dividerDouble} />
            </Row>

            <Row className={styles.editLink}>
              <Table
                name="ProjectsOverviewTable"
                colsConfig={["16%", "17%", "17%", "17%", "17%", "16%"]}
                tableData={projectsTableData}
              />
            </Row>

            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Weekly Projects</h2>
              <div className={styles.chartOptions}>
                <a
                  onClick={() => this.onWeeklyProjectsChange(0)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyProjectsSelected.label === "Created"
                  })}
                >
                  CREATED
                </a>
                <a
                  onClick={() => this.onWeeklyProjectsChange(1)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyProjectsSelected.label === "Approved"
                  })}
                >
                  APPROVED
                </a>
                <a
                  onClick={() => this.onWeeklyProjectsChange(2)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyProjectsSelected.label === "Pitched"
                  })}
                >
                  PITCHED
                </a>
                <a
                  onClick={() => this.onWeeklyProjectsChange(3)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyProjectsSelected.label === "Hired"
                  })}
                >
                  SELECTED
                </a>
              </div>
            </div>

            <Row>
              <BarChart dataset={weeklyProjectsDataset} />
            </Row>

            <Row className={styles.editLink}>
              <Table
                name="MembersOverviewTable"
                colsConfig={["16%", "17%", "17%", "17%", "17%", "16%"]}
                tableData={membersTableData}
              />
            </Row>

            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Weekly Members</h2>
              <div className={styles.chartOptions}>
                <a
                  onClick={() => this.onWeeklyUsersChange(0)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyUsersSelected.label === "Signed Up"
                  })}
                >
                  SIGNED UP
                </a>
                <a
                  onClick={() => this.onWeeklyUsersChange(1)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyUsersSelected.label === "Accepted"
                  })}
                >
                  ACCEPTED
                </a>
                <a
                  onClick={() => this.onWeeklyUsersChange(2)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyUsersSelected.label === "Matched"
                  })}
                >
                  MATCHED
                </a>
                <a
                  onClick={() => this.onWeeklyUsersChange(3)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyUsersSelected.label === "Pitched"
                  })}
                >
                  PITCHED
                </a>
                <a
                  onClick={() => this.onWeeklyUsersChange(4)}
                  className={classnames({
                    [styles.active]:
                      this.state.weeklyUsersSelected.label === "Hired"
                  })}
                >
                  SELECTED
                </a>
              </div>
            </div>

            <Row>
              <BarChart dataset={weeklyUsersDataset} />
            </Row>
          </Grid>
        </section>
      </section>
    );
  }
}

export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/routes/admin/dashboard/components/AdminDashboard.js